import {
    COMMODITY_LIST,
    COMMODITY_PAGINATION
} from './constant';

export const initStateFeed = {
    commodityList: [],
    pagination: {},
};

export default (state = initStateFeed, action) => {
    switch (action.type) {
        case COMMODITY_LIST: {
            return {
                ...state,
                commodityList: action.payload,
            };
        }
        case COMMODITY_PAGINATION: {
            return {
                ...state,
                pagination: action.payload,
            };
        }
        default:
            return state;
    }
};
 